// eslint-disable-next-line no-shadow
enum PATHS {
  SIGNIN = '/',
  FORGOTPASSWORD = '/forgot-password',
  RECOVER_PASSWORD = '/recuperar-senha',
  SIGNUP = '/signup',
  SIGNUPCONTRACTOR = '/signup-contractor',
  SIGNUPCOMPANY = '/signup-company',
  SIGNUPDOCTOR = '/signup-doctor',
  DASHBOARD = '/dashboard',
  VACANCY_CENTER = '/central-de-vagas',
  DEMAND = '/demanda',
  DEMAND_TARGETS = '/demanda/quadro-meta',
  DEMAND_CHANGES = '/demanda/o-que-mudou',
  NEW_COMPONENTS = '/new-components',
  UNITS = '/unidades',
  UNIT_PIN_REVIEW = '/unidades/revisao-pino',
  UNIT_DETAIL = '/unidades/:healthUnitId',
  CONSULT = '/consultar',
  DOCTORS = '/medicos',
  DOCTOR_DETAIL = '/medicos/:doctorId',
  POLICIES_HOME = '/politicas',
  POLICIES = '/politicas/restricao',
  QUALIFICATION_DOC = '/politicas/qualificacao-documental',
  QUALIFICATION_TRANSFER = '/politicas/qualificacao-repasse',
  IMPORT_VALIDATIONS = '/politicas/importar-validacoes',
  AUDITORIUM_EXCEPTIONALITIES = '/pedidos-de-excepcionalidade',
  APPROVALS = '/aprovacoes',
  APPROVALS_HANDOVERS = '/aprovacoes/trocas',
  APPROVALS_EXCEPTIONALITIES = '/aprovacoes/excepcionalidades',
  APPROVALS_DS_ATTENDANCE = '/aprovacoes/registro-de-plantao',
  APPROVALS_CHECK_VALIDATION = '/aprovacoes/avaliacao-de-evidencias',
  APPROVALS_FACIAL_BIOMETRY = '/aprovacoes/biometria-facial',
  APPROVALS_PRIORITY_PAYMENTS = '/aprovacoes/pagamentos-prioritarios',
  APPROVALS_PROFESSIONAL_DOCUMENTS = '/aprovacoes/revisao-de-documentos',
  HANDOVER_EVALUATION = '/aprovacoes/trocas/:packageId/analisar',
  HANDOVER_DETAILS = '/aprovacoes/trocas/:packageId/detalhes',
  DS_ATTENDANCE_PENDING_AUDIT = '/aprovacoes/registro-de-plantao/:attendanceId/auditoria-pendente',
  DS_ATTENDANCE_PENDING_SUBMISSION = '/aprovacoes/registro-de-plantao/:attendanceId/envio-pendente',
  DS_ATTENDANCE_APPROVED = '/aprovacoes/registro-de-plantao/:attendanceId/aprovado',
  MANAGE_DOCTOR_AUTHORIZATION_POLICIES = '/politicas/restricao/gerenciar',
  MANAGE_QUALIFICATION_TRANSFER = '/politicas/qualificacao-repasse/gerenciar',
  MANAGE_QUALIFICATION_DOC = '/politicas/qualificacao-documental/gerenciar',
  USERS = '/usuarios',
  MANAGEMENT = '/gestao',
  ANTECIPE_AFFILIATES = '/gestao/afiliados',
  AFFILIATE_ROOT = '/afiliado',
  AFFILIATE_OVERVIEW = '/afiliado/visao-geral',
  AFFILIATE_PACKAGES = '/afiliado/pacotes',
  AFFILIATE_PAYOUT = '/afiliado/repasse',
  AFFILIATE_UNITS = '/afiliado/unidades',
  PROFILE = '/perfil',
  ACCESS_MANAGER = '/gerenciar-acesso',
  MANAGE_SCALE = '/gerenciar-escala',
  POST_STATION = '/pos-plantao',
  CONTRACTS = '/contratos',
  MANAGE_DOCTOR_INVITE = '/convite',
  REPORTS = '/relatorios',
  CHANGELOG = '/changelog',
  ANNOUNCEMENTS = '/comunicados',
  ANNOUNCEMENT_NEW = '/comunicados/novo',
  ANNOUNCEMENT_DETAIL = '/comunicados/:announcementId',
  TERMS = '/termos-de-ciencia',
  TERMS_HISTORY = '/termos-de-ciencia/historico',
  TERM_VERSION_DETAIL = '/termos-de-ciencia/versoes/:versionId',
  TERM_SIGNATURES = '/termos-de-ciencia/versoes/:versionId/assinaturas',
  TERM_NEW_VERSION = '/termos-de-ciencia/:modality/nova-versao',

  NPS_DASHBOARD = '/avaliacao-medica',
  NPS_SETTINGS = '/nps/configuracoes',
  NPS_EVALUATION = '/nps/avaliacoes',
  NPS_EDITOR = '/nps/editor',
  NPS_PUBLIC_FORM = '/nps/avaliacao',
  NPS_PUBLIC_FORM_LINK = '/nps/public/health-unit/:healthUnitId',
  NPS_ANSWER_DETAILS = '/nps/respostas/:id',

  // Modo TV público do Mapa da unidade (Onda 2.4): sem login, pelo token do link.
  UNIT_MAP_TV = '/tv/:token',

  // Link público do convite de alocação (acceptance-terms): o médico aceita sem login.
  ALLOCATION_INVITE_ACCEPT = '/aceite/:token',

  // Backoffice: telas administrativas de uso restrito, fora do menu.
  BACKOFFICE_EFFECTIVE_CHECK_RECOMPUTE = '/backoffice/horario-efetivo/recalculo',

  NOT_AUTHORIZED = '/not-authorized',
  // Carga das permissões falhou (rede/5xx): tela de retry, distinta de "sem acesso".
  PERMISSIONS_UNAVAILABLE = '/permissoes-indisponiveis'
}

export default PATHS
